<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
import jobTypeColors from "@/utils/iconType";
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
  },
  data() {
    return {
      jobTypeColors,
      chart: null,
      options: {
        tooltip: {
          show: false,
          position: function (pos, params, dom, rect, size) {
              // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
              let obj = {top: -50};
              obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
              return obj;
          },
          trigger: "axis",
          borderColor: 'rgba(10, 69, 31, 0.8)',
          backgroundColor: 'rgba(10, 69, 31, 0.8)',
          axisPointer: {
            type: "cross",
            label: {
              color: '#ffffff',
              backgroundColor: "rgba(10, 69, 31, 0.8)",
            },
          },
          formatter(params) {
            let dom = '';
            params.map((v,i)=>{
              let itemData = params[(params.length - i)-1];
              dom+= `
              <div style="margin: 0px 0 12px;line-height:1;">
									<div style="margin: 0px 0 0;line-height:1;">
                    ${itemData.marker}
                    <span style="font-size:12px;color:#fff;font-weight:400;margin-left:-2px">${itemData.seriesName || '--'}</span>
                    <span style="float:right;margin-left:20px;font-size:14px;color:#fff;font-weight:900;">${itemData.value || '0'}</span>
									</div>
								</div>`
            });
            let topDom = params && params.length>0 ? `<div style="font-size:14px;color:#fff;font-weight:400;line-height:1;margin-bottom: 10px">${params[0].axisValueLabel}</div>`:''
            return `<div>${topDom}${dom}</div>`;
          },
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#0A1D31",
            }
          },
        },
        color: function (params) {
          return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
              offset: 0,
              color: colorList[params.seriesIndex].c1,
            },
            {
              offset: 1,
              color: colorList[params.seriesIndex].c2,
            },
          ]);
          /*  return colorList[params.dataIndex]*/
        },
        legend: {
          show: false,
          orient: "horizontal",
          x: "right",
          y: "top",
          data: [],
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: "#62D9AD",
            fontSize: 12,
          },
        },
        grid: {
          right: "20",
          left: "13.5%",
          top: "16.5%",
          bottom:"18.6%"
        },
        xAxis: [
          {
            axisLabel: {
              interval: 0,
              color: "#ffffff",
              fontSize: 12,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              rotate: -60
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#ffffff",
              },
              width: 1,
            },
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
          },
        ],
        yAxis: {
          minInterval: 1,
          name: "单位(台)",
          type: "value",
          nameTextStyle: {
            color: "#62D9AD",
            fontSize: 12,
            align: 'right',
            padding: [0, 0, 0, 0]
          },
          axisLabel: {
            interval: 0,
            color: "#ffffff",
            fontSize: 12,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#ffffff",
            },
            width: 5,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(13, 255, 169, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {

        this.initChart();

      },
    },
  },
  mounted() {
    this.initChart();
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      let that = this;
      let series = [];
      if (this.chartData.regionProductionList) {

        for (
          let index = 0;
          index < this.chartData.regionProductionList.length;
          index++
        ) {
          const el = this.chartData.regionProductionList[index];
          let dataVal = [];
          el.datas.map((item) => {
            dataVal.push(item.onlineSum);
          });

          series.push({
            name: el.vehicleTypeName,
            type: "bar",
            stack: "总量",
            barWidth: "45%",
            label: {
              show: this.chartData.regionProductionList.length == 1 ? true:false,
              position: "top",
              color: '#fff',
              formatter(v) {
                if (v.value <= 0) {
                  return "";
                } else {
                  return v.value;
                }
              },
            },
            itemStyle: {
              normal: {
                // 折点颜色
                color: function (params) {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                      offset: 0,
                      color: that.jobTypeColors[String(el.vehicleType)]
                        ? that.jobTypeColors[String(el.vehicleType)].echartsJobFill
                        : that.jobTypeColors["default"].echartsJobFill,
                    },
                    {
                      offset: 1,
                      color: that.jobTypeColors[String(el.vehicleType)]
                        ? that.jobTypeColors[String(el.vehicleType)].echartsJobLight
                        : that.jobTypeColors["default"].echartsJobLight,
                    },
                  ]);
                },
              },
            },
            data: dataVal,
          });
        };
        this.options.legend.data = this.chartData.legends;
        this.options.series = series;
        this.chart.setOption(this.options,true); // 设置为true的话，就是notMerge，不合并,false的话，就Merge，之前的东西还保留~

      }
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
  },
};
</script>
